/* eslint-disable */
import { isEmpty } from 'lodash';
export default (data, currentLanguage) => {
  return !isEmpty(data) &&  data.translations && data.translations[currentLanguage]
    ? data.translations[currentLanguage]
    : data.translations && data.translations.vi;
};
